import axiosInstance from "./axios";
import { ResponseType } from "@/types/CommonTypes";
import { LanguageType } from "@/types/LanguageTypes";

export const languagesApi = {
  /** All system languages (for assignment UIs). GET /languages */
  getAllLanguages: async (): Promise<ResponseType<LanguageType[]>> => {
    try {
      const response = await axiosInstance.get("/languages");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /** Languages available for the logged-in user. GET /languages/me */
  getLanguages: async (): Promise<ResponseType<LanguageType[]>> => {
    try {
      const response = await axiosInstance.get("/languages/me");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /** Languages available for a user (client + all their groups). */
  getLanguagesForUser: async (userId: number): Promise<ResponseType<LanguageType[]>> => {
    try {
      const response = await axiosInstance.get(`/languages/users/${userId}/available`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /** Languages available for a client. */
  getLanguagesForClient: async (clientId: number): Promise<ResponseType<LanguageType[]>> => {
    try {
      const response = await axiosInstance.get(
        `/languages/clients/${clientId}/available`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /** Languages available for group(s). Union of group languages; falls back to client when groups have none. */
  getLanguagesForGroups: async (
    groupIds: number[],
    clientId?: number
  ): Promise<ResponseType<LanguageType[]>> => {
    try {
      const params = new URLSearchParams({ groupIds: groupIds.join(",") });
      if (clientId != null) {
        params.set("clientId", String(clientId));
      }
      const response = await axiosInstance.get(
        `/languages/groups/available?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
